module.exports = "<div ng-repeat=\"contact in myContacts\">\n  <my-contact-display my-contact=\"contact\">\n  </my-contact-display>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/owners/contact/directives/display/myContactsDisplay.html
// module id = 843
// module chunks = 0